<div class="wrapper">
<div class="panelHolder">
 <div class="panel">
    
    <div class="panel-body-error">
        
        <p class="textsuccess">{{"ReceiptAuthentication.SuccessMsg" | translate}}</p> 
        <!-- <p>You will receive an email with download link as soon as your receipt is authenticated</p>  -->

        <!-- <p>Visit us at <a href="https://www.rpost.com">https://www.rpost.com </a>to learn about RPost Services</p> -->
        <p class="textnote">{{"DownloadAuthenticatedReceipt.Note1" | translate}}<a href="https://www.rpost.com">https://www.rpost.com </a>{{"DownloadAuthenticatedReceipt.Note2" | translate}}</p>
    </div>
</div> 
</div>
</div>